import {ALERT, ERROR, LOADED, LOADING} from './AxiosSetupActions';
import {
    ADD_CLAIMED_ITEM,
    DISMISS_ALERT,
    EMPTY_CLAIMED_ITEMS,
    LOAD_THEMES,
    PROFILE_LOAD,
    REMOVE_CLAIMED_ITEM,
    UPDATE_CLAIMED_ITEMS,
    SELECT_THEME,
} from './AppTemplateActions';
import moment from 'moment';
import 'moment/locale/pl';
import {getPublicUrl} from '../../common/AppContextTools';

const assignPublicUrl = (state) => {
    const publicUrl = getPublicUrl();
    if (!state.publicUrl && publicUrl) {
        return {
            ...state,
            profile: {...state.profile, email: 'visitor'},
            roles: ['visitor'],
            publicUrl: publicUrl,
        };
    } else if (!publicUrl && state.publicUrl) {
        return {...state, profile: null, roles: [], publicUrl: null, clientTheme: null};
    } else {
        return state;
    }
};

const initialState = {
    modal: false,
    dock: false,
    token: null,
    profile: null,
    authenticated: null,
    alerts: [],
    locale: 'en',
    i: 0,
    loading: false,
    theme: 'Sandstone',
    clientTheme: null,
    themes: [],
    roles: [],
    publicUrl: null,
    map_style: null,
    claimedItems: [],
};

export default (state = initialState, action) => {
    state = assignPublicUrl(state);
    switch (action.type) {
        case LOADING:
            return {...state, loading: true};
        case LOADED:
            moment.locale(state.locale);
            return {...state, loading: false};
        case ALERT:
            return {
                ...state,
                alerts: state.alerts.concat({...action.alert, type: 'success', id: initialState.i++}),
            };
        case ERROR:
            return {
                ...state,
                alerts: state.alerts.concat({...action.alert, type: 'warning', id: initialState.i++}),
            };
        case DISMISS_ALERT:
            return {
                ...state,
                alerts: state.alerts.filter(a => a.id !== action.alert.id),
            };
        case ADD_CLAIMED_ITEM:
            return {
                ...state,
                claimedItems: state.claimedItems.concat(action.claimedItem),
            };
        case REMOVE_CLAIMED_ITEM:
            return {
                ...state,
                claimedItems: state.claimedItems.filter(c => c.id !== action.claimedItem),
            };
        case UPDATE_CLAIMED_ITEMS:
            return {
                ...state,
                claimedItems: action.claimedItems,
            };
        case EMPTY_CLAIMED_ITEMS:
            return {
                ...state,
                claimedItems: [],
            };
        case PROFILE_LOAD:
            const locale = action.profile.locale || state.locale;
            moment.locale(locale);
            return {
                ...state,
                profile: action.profile,
                role: action.profile.role,
                locale,
            };
        case LOAD_THEMES:
            return {...state, themes: action.themes};
        case SELECT_THEME:
            return {...state, theme: action.theme};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/containers/template/AppReducer.js